import classNames from 'clsx';
import React, { useContext } from 'react';

import type { CasinoSecondaryNavigation, Top } from '@swf/cms';
import { CMSContext } from '@swf/cms';
import type { CasinoSecondaryNavigationBlock } from '@swf/generated/cms/types/Top';

import styles from '../../styles/styles.scss';

import TopBodyItem from './TopBodyItem';

const CMSTop: React.FC<Top> = ({ body }) => {
  const content = useContext(CMSContext);
  const casinoSecondaryNavigation = body.find(
    (item) => (item as CasinoSecondaryNavigationBlock).casino_secondary_navigation
  );
  let sticky = false;
  if (casinoSecondaryNavigation) {
    const [reference] = (casinoSecondaryNavigation as CasinoSecondaryNavigationBlock)
      .casino_secondary_navigation.reference;
    ({ sticky } = content[reference.uid] as CasinoSecondaryNavigation);
  }

  return (
    <div className={classNames(styles.topContainer, { [styles.sticky]: sticky })}>
      {body.map((item, index) => (
        <TopBodyItem key={index} {...item} />
      ))}
    </div>
  );
};

export default CMSTop;
